import { useContext } from "react";
import { UIContext } from "@middleware/contexts";
import { StateUi } from "@middleware/types";

export const useUI = () => {
  const context = useContext<StateUi>(UIContext);

  return context;
};
